import { useEffect } from "react"
import { useLocation } from "@tanstack/react-router"

export function ScrollToTop() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    // Scroll window
    window.scrollTo(0, 0)
    
    // Scroll all scrollable main containers inside shells
    const scrollableElements = document.querySelectorAll("main, .overflow-y-auto")
    scrollableElements.forEach((el) => {
      el.scrollTop = 0
    })
  }, [pathname, search])

  return null
}
